import { MP_WEBAPP_RESOURCE_PARAM } from './constants';

export const getLabel = (labels, key) => labels[key] || '';

export const getUserLocale = () => {
	const locale = sessionStorage.getItem('visitorLocale');
	return locale || 'en-US';
};

export const userCanPurchase = (data) => {
	const locationSearchParams = new URLSearchParams(window.location.search);
	return data.purchase && locationSearchParams.has(MP_WEBAPP_RESOURCE_PARAM);
};
